import * as users from "mortar/endpoints/users";

export const updateLastAccessed = () => users.updateUserLastAccessed();
